import { queryParams, searchPage } from '@/shared/constants/constants';
import { getSearchQuery } from '@/shared/tracking/search-used';
import type { RelewiseFailureReason } from '@/shared/utils/relewise-fallback-reason';
import {
  buildNativeSearchUrl,
  isNativeSearchView,
  isSearchPage
} from '@/shared/utils/search-urls';

let redirected = false;

export const redirectToNativeResults = (
  reason: RelewiseFailureReason
): void => {
  if (redirected || !isSearchPage() || isNativeSearchView()) {
    return;
  }

  const term = getSearchQuery()?.trim();
  if (!term) {
    return;
  }

  redirected = true;
  window.location.replace(
    buildNativeSearchUrl(term, searchPage.NATIVE_VIEW, {
      [queryParams.RELEWISE_FALLBACK_REASON]: reason
    })
  );
};

/** Test-only: allow another redirect so each spec starts clean. */
export const __resetNativeResultsRedirectForTests = () => {
  redirected = false;
};

export const redirectRelewiseUrlToNative = (): boolean => {
  if (!isSearchPage()) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const term = params.get(queryParams.RELEWISE_SEARCH_QUERY)?.trim();

  if (!term || params.has(queryParams.SEARCH_QUERY)) {
    return false;
  }

  window.location.replace(buildNativeSearchUrl(term));
  return true;
};
